export const isFirefox = window.navigator.userAgent.includes('Firefox');

export const prefersReducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

/* we also got a vuex getter ui/prefersReducedMotion */
export function prefersReducedMotion() {
    return prefersReducedMotionQuery.matches;
}
